import { Component, Input } from '@angular/core';
import { Filter } from '../../models/filter-models';
import { BaseComponent } from '../base.component';

@Component({
  selector: 'app-mod-tier-explainer',
  standalone: true,
  imports: [],
  templateUrl: './mod-tier-explainer.component.html',
  styleUrl: './mod-tier-explainer.component.scss'
})
export class ModTierExplainerComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input() quickFiltersVersion: boolean = false;
}

